import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, BarChart, Book, Video, LogOut, X, Menu } from "lucide-react";
import { toast } from "react-toastify";

const SideBar = ({ setIsAuthenticated }) => {
  const [active, setActive] = useState("home");
  const [showLogout, setShowLogout] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    if (path === "/home") setActive("home");
    else if (path === "/howto") setActive("how-to");
    else if (path === "/history") setActive("history");
    else if (path === "/stats") setActive("stats");
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("idToken");
    localStorage.setItem("isNewUser", "false");
    localStorage.removeItem("hasCompletedOnboarding");

    toast.success("Logged out successfully!", {
      position: "top-center",
      autoClose: 2000,
    });

    setTimeout(() => {
      navigate("/welcome");
    }, 2000);
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 text-gray-300"
        onClick={() => setSidebarOpen(true)}
      >
        <Menu size={28} />
      </button>

      {/* Sidebar */}
      <div
        className={`fixed  md:static top-0 left-0 h-full md:w-auto w-48 bg-[#1A1716] p-4 text-gray-400 flex flex-col items-center justify-between transition-transform z-40 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
      >
        {/* Close button (mobile only) */}
        <button
          className="md:hidden self-end text-[#C6E675] mb-4"
          onClick={() => setSidebarOpen(false)}
        >
          <X size={24} />
        </button>

        <ul className="space-y-8 w-full flex-1 flex flex-col items-center">
          <Link to="/home" onClick={() => setSidebarOpen(false)}>
            <li
              className={`flex flex-col items-center gap-1 p-2 cursor-pointer transition-all ${
                active === "home" ? "text-[#C6E675]" : "hover:text-[#C6E675]"
              }`}
            >
              <Home size={24} />
              <span className="text-sm font-medium">Home</span>
            </li>
          </Link>

          <Link to="/howto" onClick={() => setSidebarOpen(false)}>
            <li
              className={`flex flex-col items-center gap-1 p-2 cursor-pointer transition-all ${
                active === "how-to" ? "text-[#C6E675]" : "hover:text-[#C6E675]"
              }`}
            >
              <Book size={24} />
              <span className="text-sm font-medium">How-to</span>
            </li>
          </Link>

          <Link to="/history" onClick={() => setSidebarOpen(false)}>
            <li
              className={`flex flex-col items-center gap-1 p-2 cursor-pointer transition-all ${
                active === "history" ? "text-[#C6E675]" : "hover:text-[#C6E675]"
              }`}
            >
              <Video size={24} />
              <span className="text-sm font-medium">History</span>
            </li>
          </Link>

          <Link to="/stats" onClick={() => setSidebarOpen(false)}>
            <li
              className={`flex flex-col items-center gap-1 p-2 cursor-pointer transition-all ${
                active === "stats" ? "text-[#C6E675]" : "hover:text-[#C6E675]"
              }`}
            >
              <BarChart size={24} />
              <span className="text-sm font-medium">Statistics</span>
            </li>
          </Link>
        </ul>

        {/* Logout Button */}
        <button
          onClick={() => {
            setShowLogout(true);
            setSidebarOpen(false);
          }}
          className="flex flex-col items-center gap-3 p-2 transition-all text-[#CBDF52] hover:text-[#CBDF52]"
        >
          <LogOut size={24} />
          <span className="text-sm font-medium">Log out</span>
        </button>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogout && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-[#292929] p-6 rounded-xl shadow-lg text-center w-[90%] max-w-[425px] relative border border-[#92929266]">
            <button
              onClick={() => setShowLogout(false)}
              className="absolute top-3 right-3 text-[#C6E675]"
            >
           
            </button>

            <h2 className="text-[22px] md:text-[25px] font-semibold text-white mb-2">
              Are you sure you want to log out?
            </h2>
            <p className="text-sm text-white-400 mb-6">
              You’ll need to log in again to continue.
            </p>

            <div className="flex justify-center items-center space-x-8">
              <button
                onClick={() => setShowLogout(false)}
                className="text-gray-300 text-lg font-medium hover:text-white transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-[#C6E675] text-black text-lg font-medium rounded-lg transition-all hover:brightness-90"
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideBar;